/*
  MOMERY CUSTOM: Hintergrundvideo (sections/background-video.liquid) in Safari/iOS starten.

  Habitat 14 legt das <video> in ein <template> und klont es erst beim Heranscrollen.
  Der Klon entsteht dabei im inerten Template-Dokument; WebKit startet ihn danach nicht
  von selbst. Dieser Helfer
  - erzeugt die Kopie mit importNode direkt im Seitendokument,
  - setzt muted/playsinline als Eigenschaft und ruft play() ausdrücklich auf,
  - versucht es erneut, sobald das Video im Bild ist, und nach einem echten Tippen,
    falls der Browser den Start ablehnt (z. B. Stromsparmodus),
  - lässt bis zum ersten laufenden Bild das Ersatzbild der Section oben liegen,
    damit nie das 100 px kleine Vorschaubild oder ein nicht antippbarer Play-Knopf
    zu sehen ist.
  Aufgerufen wird er aus dem markierten Hook in assets/background-video.js.
*/
(function (root) {
  'use strict';
  if (root.MomeryBackgroundVideo) return;

  var WAITING = 'momery-background-video--waiting';
  var GESTURES = ['click', 'touchend', 'keydown'];
  var LISTENER_OPTIONS = { capture: true, passive: true };

  function importContent(template, doc) {
    return (doc || root.document).importNode(template.content, true);
  }

  function start(container, doc) {
    doc = doc || root.document;
    var video = container ? container.querySelector('video') : null;
    if (!video || video.momeryBackgroundVideo) return null;
    video.momeryBackgroundVideo = true;

    var section = container.closest('background-video');
    var hasFallback = !!(section && section.querySelector('.background-video__fallback-img'));
    var inView = true; // Habitat ruft erst auf, wenn die Section kurz vor dem Bildschirm ist
    var listening = false;
    var observer = null;
    var stopped = false;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    if (hasFallback) section.classList.add(WAITING);

    function stopListening() {
      if (!listening) return;
      listening = false;
      GESTURES.forEach(function (name) {
        doc.removeEventListener(name, attempt, LISTENER_OPTIONS);
      });
    }

    function teardown() {
      stopped = true;
      stopListening();
      if (observer) observer.disconnect();
      observer = null;
      video.removeEventListener('playing', onPlaying);
      root.removeEventListener('pageshow', attempt);
      doc.removeEventListener('shopify:section:unload', onSectionUnload);
    }

    // Theme-Editor: Die Section wird entfernt oder neu gerendert, auch wenn das Video läuft.
    function onSectionUnload(event) {
      var target = event && event.target;
      if (target && typeof target.contains === 'function' && target.contains(video)) teardown();
    }

    function onPlaying() {
      if (section) section.classList.remove(WAITING);
      stopListening();
    }

    function attempt() {
      if (stopped) return;
      if (!video.isConnected) return teardown();
      if (!inView || !video.paused) return;
      var result;
      try {
        result = video.play();
      } catch (error) {
        result = Promise.reject(error);
      }
      if (!result || typeof result.then !== 'function') return;
      result.then(null, function (error) {
        // Nur bei einer Autoplay-Sperre auf ein Tippen warten. Ein Wischen zählt in
        // WebKit nicht als Nutzergeste, deshalb bleiben die Listener bis zum Erfolg.
        if (!error || error.name !== 'NotAllowedError' || listening || stopped || !video.isConnected) return;
        listening = true;
        GESTURES.forEach(function (name) {
          doc.addEventListener(name, attempt, LISTENER_OPTIONS);
        });
      });
    }

    video.addEventListener('playing', onPlaying);
    root.addEventListener('pageshow', attempt);
    doc.addEventListener('shopify:section:unload', onSectionUnload);

    if (typeof root.IntersectionObserver === 'function') {
      observer = new root.IntersectionObserver(function (entries) {
        if (!video.isConnected) return teardown();
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
        });
        if (inView) attempt();
      });
      observer.observe(video);
    }

    attempt();
    return video;
  }

  root.MomeryBackgroundVideo = { importContent: importContent, start: start };
})(typeof window !== 'undefined' ? window : globalThis);
